import React from 'react'
import PropTypes from 'prop-types'
import {Image, Button, Flex, Text} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import {
    clearAllButtonStyles,
    filterButtonStyles,
    filterIconStyles,
    filterTextStyles
} from './index.style'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
const SkipSelectedFilterDisplay = ['cgid', 'c_availableStores']
const SIZE_ATTRIBUTES = ['c_width', 'c_size']

const SelectedRefinements = ({
    filters = [],
    toggleFilter,
    handleReset,
    selectedFilterValues = {}
}) => {
    const intl = useIntl()
    const clickGuardRef = React.useRef({})

    let selectedFiltersArray = Object.entries(selectedFilterValues)
        .filter(([attributeId]) => !SkipSelectedFilterDisplay.includes(attributeId))
        .flatMap(([attributeId, values]) => {
            const valueString = Array.isArray(values) ? values.join('|') : values
            const valueArray = valueString.split('|').filter((v) => v.trim())
            return valueArray.map((value) => ({
                attributeId,
                value: value.trim()
            }))
        })
    selectedFiltersArray = selectedFiltersArray?.filter(({attributeId, value}) => {
        if (attributeId === 'price') return true
        const selectedItem = filters?.find((filter) => filter?.attributeId == attributeId)
        return selectedItem?.values.some((item) => value == item?.value)
    })

    if (!selectedFiltersArray || selectedFiltersArray.length === 0) {
        return null
    }

    const getRefinementLabel = (attributeId, value) => {
        if (attributeId === 'price') {
            const [min, max] = value.slice(1, -1).split('..').map(Number)
            const formatCurrency = (num) =>
                Number(num).toLocaleString(undefined, {
                    style: 'currency',
                    currency: 'USD',
                    maximumFractionDigits: 0
                })
            return `${formatCurrency(min + 0.01)} - ${formatCurrency(max - 0.01)}`
        }
        const filter = filters?.find((f) => f.attributeId === attributeId)
        const valueObj = filter?.values?.find((v) => v.value === value)
        return valueObj?.label || value
    }

    const getAttributeLabel = (attributeId) => {
        const filter = filters?.find((f) => f.attributeId === attributeId)
        return filter?.label || attributeId
    }

    const handleRefinementClick = (refinement) => {
        const key = `${refinement.attributeId}-${refinement.value}`
        if (clickGuardRef.current[key]) return
        clickGuardRef.current[key] = true

        toggleFilter({value: refinement.value}, refinement.attributeId, true)

        setTimeout(() => {
            clickGuardRef.current[key] = false
        }, 300)
    }

    return (
        <Flex wrap="wrap" rowGap={2} columnGap={2} align="flex-start">
            {selectedFiltersArray.map((refinement, index) => {
                const formatDisplayText = (refinement) => {
                    const includeAttribute = SIZE_ATTRIBUTES.includes(refinement?.attributeId)
                    const attributeLabel = includeAttribute
                        ? getAttributeLabel(refinement.attributeId)
                        : ''
                    const valueLabel = getRefinementLabel(refinement.attributeId, refinement.value)
                    return [attributeLabel, valueLabel]
                        .filter((label) => label.trim())
                        .join(' ')
                        .toUpperCase()
                }
                const displayText = formatDisplayText(refinement)
                return (
                    <Button
                        variant="unstyled"
                        key={`${refinement.attributeId}-${refinement.value}-${index}`}
                        sx={filterButtonStyles}
                    >
                        <Image
                            src={getAssetUrl('static/img/plp/cross.svg')}
                            alt="Remove filter"
                            sx={filterIconStyles}
                            onClick={() => handleRefinementClick(refinement)}
                        />
                        <Text as="span" sx={filterTextStyles}>
                            {displayText}
                        </Text>
                    </Button>
                )
            })}
            {selectedFiltersArray.length > 0 && (
                <Button variant="unstyled" onClick={handleReset} sx={clearAllButtonStyles}>
                    {intl.formatMessage({
                        id: 'plp.selectedrefinements.clearall',
                        defaultMessage: 'Clear all'
                    })}
                </Button>
            )}
        </Flex>
    )
}

SelectedRefinements.propTypes = {
    filters: PropTypes.array,
    toggleFilter: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
    selectedFilterValues: PropTypes.array
}

export default SelectedRefinements
